import React from "react"
import Heading from "../../common/Heading"
import "./hero.css"

const Hero = () => {
  return (
    <>
      <section className='hero'>
        <div className='container'>
          <Heading title='Aluminium and partition Rwanda ' subtitle='Enhances space management in offices, homes, healthcare, and events by creating flexible and efficient layouts.' />

          
        </div>
      </section>
    </>
  )
}

export default Hero
